<template>
    <div>
        <div class="description-widget">
            <h3 class="module-title">
                Description
            </h3>
            <div class="row">
                <div v-for="(item, index) in getSummaryDescription" :key="index" class="col-md-6">
                    <div v-if="index < 3">
                        <h5 class="description-subtitle">
                            {{ item.label }}
                            <disclosure-superscript v-if="item.label == 'Distinguishing Characteristics'"
                                class="detail-page" anchor="desription_distChar" :statistics="['DC_SB']" />
                        </h5>
                        <p class="description-text" v-html="item.data" />
                    </div>
                </div>
                <div v-for="(item, index) in getSummaryDescription" :key="`${index}_a`" class="col-md-6">
                    <div v-if="index >= 3">
                        <h5 class="description-subtitle">
                            {{ item.label }}
                            <disclosure-superscript v-if="item.label == 'Distinguishing Characteristics'"
                                class="detail-page" anchor="desription_distChar" :statistics="['DC_SB']" />
                        </h5>
                        <p class="description-text" v-html="item.data" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'DescriptionModule',
	computed: {
		...mapGetters(['getSummaryDescription'])
	},
	watch: {
		getSummaryDescription: {
			immediate: true,
			handler(val) {
				this.$EventBus.$emit('ExcelData', 'descriptionModule', val);
			}
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/variables';

.app {
	font-family: 'AvenirNextLTW01-Regular', Arial;
	font-size: 14px;
	font-weight: 400;
	color: #333;

	.data-label {
		color: #666;
		font-size: 12px;
		margin-top: 15px;
	}

	.top {
		margin-top: 10px;
	}
}

.description-widget {
	.module-border-top();
	margin-bottom: 30px;

	.description-subtitle {
		margin-bottom: 0px;
		font-size: 12px;
		color: @gray;
		font-family: "AvenirNextLTW01-Regular", Arial;
		line-height: 18px;
	}

	.description-text {
		font-family: "AvenirNextLTW01-Regular", Arial;
	}
}
</style>
